module.exports = __webpack_public_path__ + "img/9b0d8a5.svg";